import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.modal = new window.Bootstrap.Modal(this.element);
  }

  close() {
    this.modal.hide();
  }

  submitEnd(event) {
    if (event.detail.success) {
      this.close();
    }
  }
}
